/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Prompt } from "./Prompt";
export const PromptResponse = core.serialization.object({
    data: Prompt,
});
